import classes from './icon.module.scss';

const Harborgate = (): JSX.Element => {
  return (
    <svg
      className={classes['svg']}
      xmlns='http://www.w3.org/2000/svg'
      width='64'
      height='64'
      viewBox='0 0 64 64'
      fill='none'
    >
      <path
        d='M42.2489 29.7865C46.1563 23.2464 49.7372 17.1999 49.8637 16.8234C50.1468 15.9826 49.3032 15.9826 49.3032 15.9826H45.6571C45.1599 15.9826 44.8824 16.6432 44.8268 16.7932C44.8189 16.8143 44.8094 16.8348 44.7985 16.8545L40.3277 24.3957C40.3277 24.3957 39.068 26.5953 37.2591 29.7393L42.2489 29.7865ZM52.9492 10.9335C56.8057 12.5215 56.0735 17.1206 55.6555 18.821C55.5594 19.2028 55.4091 19.5688 55.2091 19.908C54.4411 21.2205 52.0792 25.245 49.3758 29.862H49.3589C49.3742 29.8701 49.3867 29.8827 49.3945 29.8982C49.4024 29.9136 49.4053 29.9311 49.4028 29.9483C49.4003 29.9655 49.3926 29.9814 49.3807 29.994C49.3688 30.0066 49.3532 30.0152 49.3362 30.0186L21.8228 35.3424C18.1287 41.6031 14.3873 47.9526 14.2467 48.2357C13.9636 48.7971 14.8082 48.7971 14.8082 48.7971H18.174C18.4566 48.8064 18.7344 48.7226 18.9647 48.5584C18.9967 48.5345 19.0242 48.5051 19.0458 48.4716L19.5705 47.6837C19.5705 47.678 19.579 47.6724 19.5818 47.6667C19.7328 47.4053 23.0627 41.6758 27.0192 34.9168H34.2849C30.1954 41.9938 25.4104 50.2276 24.6282 51.3212C23.226 53.2839 21.8238 53.8454 21.8238 53.8454C19.8602 54.9673 12.5681 55.2475 9.76369 52.7234C7.12162 50.3475 8.20959 46.7297 8.3483 46.3117C8.35699 46.2874 8.36805 46.264 8.38132 46.2419C8.60873 45.8493 10.9479 41.8324 13.8287 36.888L12.8577 37.0767C12.7627 37.0942 12.6651 37.0925 12.5707 37.0718C12.4762 37.0511 12.3869 37.0118 12.3078 36.9562C12.2287 36.9006 12.1616 36.8298 12.1102 36.748C12.0588 36.6661 12.0242 36.5748 12.0085 36.4794L10.9706 30.3319C10.9521 30.2288 10.9566 30.123 10.9837 30.0219C11.0108 29.9207 11.0598 29.8268 11.1272 29.7468C11.1947 29.6667 11.2789 29.6025 11.374 29.5586C11.4691 29.5148 11.5726 29.4924 11.6773 29.493L18.0938 29.5553C21.8681 23.0511 25.3406 17.0772 25.467 16.8243C25.635 16.4912 25.5397 16.2836 25.4359 16.1714C25.402 16.1359 25.3611 16.1078 25.3158 16.0889C25.2704 16.0701 25.2217 16.0609 25.1726 16.0619H9.63914C9.57324 16.0612 9.50867 16.0432 9.45187 16.0098C9.39507 15.9764 9.34801 15.9287 9.31537 15.8714C9.28274 15.8141 9.26566 15.7493 9.26585 15.6834C9.26603 15.6175 9.28347 15.5528 9.31643 15.4957L12.1755 10.5579C12.2075 10.5004 12.2543 10.4526 12.3111 10.4194C12.3678 10.3862 12.4325 10.3689 12.4982 10.3692H24.6216C27.7071 10.3692 29.1706 9.91438 31.072 13.1736C33.0356 16.5394 31.3551 19.0635 31.3551 19.0635L29.1093 22.9936C29.1093 22.9936 27.4259 25.8404 25.1934 29.6214L30.1001 29.6686C34.8218 21.614 39.5285 13.6803 40.3277 12.6168C42.0111 10.3777 48.1812 8.97078 52.9492 10.9335Z'
        fill='#361C19'
      />
      <path
        d='M54.8115 48.791C54.8771 48.7922 54.9413 48.8105 54.9978 48.8441C55.0542 48.8778 55.1008 48.9255 55.1331 48.9827C55.1654 49.0399 55.1823 49.1045 55.182 49.1702C55.1816 49.2358 55.1642 49.3003 55.1314 49.3571L52.2147 54.2176C52.1817 54.2722 52.1354 54.3175 52.0801 54.3494C52.0248 54.3812 51.9624 54.3985 51.8986 54.3997H40.3254C37.8013 54.3997 35.2772 53.8392 33.3135 51.8756C31.5047 50.0667 32.0774 47.0633 32.1812 46.6056C32.1891 46.5667 32.2041 46.5296 32.2256 46.4962C32.5549 45.9451 35.6612 40.778 39.178 34.905H46.4144C42.5023 41.5885 38.7713 47.9634 38.643 48.2267C38.3599 48.7881 38.926 48.7882 38.926 48.7882H54.8115V48.791Z'
        fill='#361C19'
      />
      <path
        d='M42.2466 29.7806L37.2569 29.7334'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M13.8188 36.895L12.8478 37.0837C12.7528 37.1011 12.6552 37.0995 12.5608 37.0788C12.4663 37.0581 12.377 37.0188 12.2979 36.9632C12.2189 36.9076 12.1517 36.8368 12.1003 36.7549C12.0489 36.6731 12.0143 36.5818 11.9986 36.4864L10.9607 30.3389C10.9422 30.2358 10.9467 30.13 10.9738 30.0288C11.0009 29.9277 11.0499 29.8338 11.1173 29.7537C11.1848 29.6737 11.269 29.6094 11.3641 29.5656C11.4592 29.5217 11.5627 29.4994 11.6674 29.5L18.0839 29.5623'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M21.8205 35.3421L49.3338 30.0221C49.3508 30.0187 49.3664 30.0101 49.3783 29.9975C49.3902 29.9849 49.398 29.969 49.4004 29.9518C49.4029 29.9346 49.4 29.9171 49.3922 29.9017C49.3843 29.8862 49.3718 29.8736 49.3565 29.8655'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M30.0939 29.6793L25.191 29.6321'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M46.4144 34.9087H39.178'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M34.276 34.9126H27.0141'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M49.3788 29.8655H49.3565'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M21.8205 35.3382C18.1264 41.5989 14.385 47.9484 14.2444 48.2314C13.9613 48.7929 14.8058 48.7929 14.8058 48.7929H18.1716C18.4543 48.8022 18.7321 48.7183 18.9624 48.5542C18.9944 48.5303 19.0218 48.5009 19.0435 48.4673L19.5682 47.6794C19.5682 47.6738 19.5767 47.6681 19.5795 47.6625C19.7305 47.4011 23.0604 41.6716 27.0169 34.9126'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M13.8189 36.8913C10.9381 41.8358 8.5989 45.8555 8.37149 46.2452C8.35822 46.2673 8.34716 46.2907 8.33846 46.315C8.2007 46.733 7.11179 50.3508 9.75386 52.7268C12.5582 55.2509 19.8503 54.9706 21.814 53.8487C21.814 53.8487 23.2161 53.2873 24.6183 51.3246C25.4006 50.2309 30.1855 41.9962 34.2751 34.9202'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M39.1779 34.905C35.6611 40.778 32.5548 45.9451 32.2227 46.4962C32.2009 46.5295 32.1855 46.5666 32.1774 46.6056C32.0764 47.0633 31.5037 50.0667 33.3097 51.8756C35.2733 53.8392 37.7974 54.3997 40.3216 54.3997H51.8985C51.963 54.3992 52.0262 54.3822 52.0822 54.3503C52.1382 54.3184 52.1851 54.2727 52.2184 54.2176L55.1351 49.3571C55.1679 49.3003 55.1854 49.2358 55.1857 49.1702C55.186 49.1045 55.1692 49.0399 55.1368 48.9827C55.1045 48.9255 55.0579 48.8778 55.0015 48.8441C54.9451 48.8105 54.8808 48.7922 54.8152 48.791H38.9231C38.9231 48.791 38.357 48.791 38.6401 48.2295C38.7712 47.9663 42.4994 41.5913 46.4115 34.9079'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M30.0939 29.6696C34.8195 21.6151 39.5261 13.6813 40.3253 12.6179C42.0087 10.374 48.1789 8.97183 52.9469 10.9345C56.8033 12.5226 56.0711 17.1217 55.6531 18.822C55.557 19.2038 55.4067 19.5699 55.2068 19.909C54.4387 21.2216 52.0769 25.246 49.3735 29.863'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M37.2569 29.7357C39.0667 26.5916 40.3255 24.3921 40.3255 24.3921L44.7962 16.8509C44.8072 16.8312 44.8166 16.8107 44.8245 16.7896C44.8802 16.6405 45.1576 15.979 45.6549 15.979H49.3009C49.3009 15.979 50.1417 15.979 49.8614 16.8197C49.735 17.1972 46.1541 23.2428 42.2466 29.7829C42.2296 29.8083 42.2155 29.8367 42.1995 29.8621'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
      <path
        d='M18.0876 29.5474C21.8619 23.0432 25.3344 17.0693 25.4608 16.8164C25.6288 16.4833 25.5335 16.2757 25.4297 16.1635C25.3958 16.128 25.3549 16.0999 25.3096 16.081C25.2642 16.0622 25.2155 16.053 25.1664 16.054H9.63672C9.57082 16.0533 9.50625 16.0353 9.44945 16.0019C9.39265 15.9685 9.34559 15.9208 9.31296 15.8635C9.28032 15.8062 9.26324 15.7414 9.26343 15.6755C9.26361 15.6096 9.28105 15.5449 9.31401 15.4878L12.1731 10.5509C12.2051 10.4935 12.2519 10.4456 12.3086 10.4124C12.3654 10.3792 12.4301 10.3619 12.4958 10.3622H24.6191C27.7047 10.3622 29.1682 9.90742 31.0695 13.1666C33.0332 16.5324 31.3526 19.0565 31.3526 19.0565L29.1069 22.9866C29.1069 22.9866 27.4235 25.8334 25.1909 29.6144'
        stroke='white'
        strokeWidth='0.5'
        strokeMiterlimit='10'
      />
    </svg>
  );
};
export default Harborgate;
